// Fechas "de calendario" (sin hora ni zona horaria), como la fecha de
// nacimiento. Se manejan siempre como cadenas `YYYY-MM-DD`: nunca se deben
// convertir a `Date` para enviarlas al servidor, porque `JSON.stringify` las
// pasa a UTC y, según la zona horaria del navegador, cambia el día.

const DATE_ONLY = /^(\d{4})-(\d{2})-(\d{2})/;
const DAY_MS = 24 * 60 * 60 * 1000;

// Normaliza a `YYYY-MM-DD`. Acepta `YYYY-MM-DD` (lo que devuelve el servidor y
// el `<input type="date">`) y, por compatibilidad, instantes con hora, que se
// redondean al día UTC más cercano. Devuelve '' si no es una fecha válida.
export const toDateOnly = (value) => {
  if (!value) return '';
  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value.trim())) return value.trim();
  const instant = new Date(value);
  if (Number.isNaN(instant.getTime())) return '';
  return new Date(instant.getTime() + DAY_MS / 2).toISOString().slice(0, 10);
};

const parts = (value) => {
  const match = DATE_ONLY.exec(toDateOnly(value));
  return match ? { year: match[1], month: match[2], day: match[3] } : null;
};

// `YYYY-MM-DD` -> `DD/MM/YYYY` (o con el separador indicado).
export const formatDateOnly = (value, separator = '/') => {
  const p = parts(value);
  return p ? [p.day, p.month, p.year].join(separator) : '';
};

// `DD-MM-YYYY` (texto escrito por el usuario) -> `YYYY-MM-DD`, o null si no es válido.
export const parseDayMonthYear = (text) => {
  if (!text) return null;
  const [day, month, year] = text.split('-').map(Number);
  if (!day || !month || !year) return null;
  const check = new Date(Date.UTC(year, month - 1, day));
  if (check.getUTCFullYear() !== year || check.getUTCMonth() !== month - 1 || check.getUTCDate() !== day) return null;
  return `${String(year).padStart(4, '0')}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
};

// `Date` a medianoche local del día indicado (para cálculos como la edad).
export const dateOnlyToLocalDate = (value) => {
  const p = parts(value);
  return p ? new Date(Number(p.year), Number(p.month) - 1, Number(p.day)) : null;
};
